/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeNavTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Nav Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:37 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const NAVTYPE_LIST_CONTAINER_LOADED = 'NAVTYPE_LIST_CONTAINER_LOADED';
export const NAVTYPE_LIST_CONTAINER_UNLOADED = 'NAVTYPE_LIST_CONTAINER_UNLOADED';
export const NAVTYPE_LIST_TABLE_LOADED = 'NAVTYPE_LIST_TABLE_LOADED';
export const NAVTYPE_LIST_TABLE_UNLOADED = 'NAVTYPE_LIST_TABLE_UNLOADED';
export const NAVTYPE_SELECT_ROW = 'NAVTYPE_SELECT_ROW';
export const NAVTYPE_ADD = 'NAVTYPE_ADD';
export const NAVTYPE_EDIT = 'NAVTYPE_EDIT';
export const NAVTYPE_DELETE = 'NAVTYPE_DELETE';
export const NAVTYPE_OPEN_WARNING = 'NAVTYPE_OPEN_WARNING';
export const NAVTYPE_CLOSE_WARNING = 'NAVTYPE_CLOSE_WARNING';

export const NAVTYPE_EDIT_CONTAINER_LOADED = 'NAVTYPE_EDIT_CONTAINER_LOADED';
export const NAVTYPE_EDIT_CONTAINER_UNLOADED = 'NAVTYPE_EDIT_CONTAINER_UNLOADED';
export const NAVTYPE_EDIT_FORM_LOADED = 'NAVTYPE_EDIT_FORM_LOADED';
export const NAVTYPE_EDIT_FORM_UNLOADED = 'NAVTYPE_EDIT_FORM_UNLOADED';
export const NAVTYPE_EDIT_DATA_LOAD = 'NAVTYPE_EDIT_DATA_LOAD';
export const NAVTYPE_EDIT_CONTAINER_SUBMIT = 'NAVTYPE_EDIT_CONTAINER_SUBMIT';
export const NAVTYPE_EDIT_CONTAINER_CANCEL = 'NAVTYPE_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeNavTypes.js